import DomSelection from '@intercom/embercom-composer/lib/editor/dom-selection';
import Constants from '@intercom/embercom-composer/lib/constants';
import $ from 'jquery';
import Em from 'ember';
export default Em.Object.extend({
  isRangeSelection: false,
  setup: Em.on('init', function () {
    this.set('domSelection', DomSelection.create());
  }),
  isRange() {
    return this.get('domSelection').isDomRange();
  },
  getCoords($editor) {
    return this.get('domSelection').getCoords($editor);
  },
  getDimensions($editor) {
    return this.get('domSelection').getDimensions($editor);
  },
  getDomSelection() {
    return this.get('domSelection.selection');
  },
  getSelection($editor) {
    let selection = this.get('domSelection').getSelection($editor);
    if (selection) {
      this.set('isRangeSelection', this.isRange());
      return selection;
    }
    if ($editor && $editor.find('.block-is-current').length) {
      let blockIndex = $editor.children().index($editor.find('.block-is-current'));
      return {
        startBlockIndex: blockIndex,
        startItemIndex: 0,
        startPositionIndex: 0,
        endBlockIndex: blockIndex,
        endItemIndex: 0,
        endPositionIndex: 0
      };
    }
    this.set('isRangeSelection', false);
    return false;
  },
  selectAll($editor) {
    this.clearBlockSelection($editor);
    this.get('domSelection').selectAll($editor);
  },
  setDomSelection(startNode, startOffset, startBlockIndex, endNode, endOffset, endBlockIndex) {
    this.get('domSelection').setDomSelection(startNode, startOffset, startBlockIndex, endNode, endOffset, endBlockIndex);
  },
  updateSelection(selection, $editor) {
    let startBlockIndex = selection.get('startBlockIndex');
    let startPositionIndex = selection.get('startPositionIndex');
    let endBlockIndex = selection.get('endBlockIndex');
    let endPositionIndex = selection.get('endPositionIndex');
    this.clearBlockSelection($editor);
    if (startBlockIndex === endBlockIndex && startPositionIndex === endPositionIndex && $editor.children().eq(startBlockIndex).is('ic-block')) {
      this.selectBlock($editor, startBlockIndex);
      this.get('domSelection').putCaretAtStart($editor.children().eq(startBlockIndex));
    } else {
      this.get('domSelection').updateCaret(selection, $editor);
    }
    this.set('isRangeSelection', this.isRange());
  },
  clearBlockSelection($editor) {
    $editor.find('.block-is-current').removeClass('block-is-current');
  },
  clearDomSelection() {
    this.get('domSelection').clear();
    this.set('isRangeSelection', false);
  },
  selectCurrentBlockForCopy($editor) {
    let $currentBlock = $editor.find('.block-is-current');
    /* @pat - Disabling the sanitization lint as DOMPurify has issues with stripping the <zws> custom tag when we don't want it to */
    /* eslint-disable-next-line jquery-unsafe/no-before */
    $currentBlock.before($(`<zws class="copy-boundry">${Constants.ZERO_WIDTH_SPACE}<zws>`));
    /* eslint-disable-next-line jquery-unsafe/no-after */
    $currentBlock.after($(`<zws class="copy-boundry">${Constants.ZERO_WIDTH_SPACE}<zws>`));
    this.get('domSelection').selectNode($currentBlock[0]);
  },
  removeCopyBoundry($editor) {
    $editor.remove('.copy-boundry');
  },
  selectBlock($editor, index) {
    let $block = $editor.children().eq(index);
    $editor.find('.block-is-current').removeClass('block-is-current');
    $block.addClass('block-is-current');
  },
  isSelectionWithinASingleBlock($editor) {
    let selection = this.get('domSelection').getSelection($editor);
    if (!selection) {
      return false;
    }
    return selection.startBlockIndex === selection.endBlockIndex && selection.startItemIndex === selection.endItemIndex;
  },
  splitEntity(type) {
    this.get('domSelection').splitEntity(type);
  },
  forceIntoNextEntityOfType(type) {
    this.get('domSelection').forceIntoNextEntityOfType(type);
  }
});